import { create } from "zustand";

/** User shape returned by auth/me/ */
export interface SessionUser {
  id?: string | number | null;
  username?: string | null;
  email?: string | null;
  roles?: string[] | null;
  [key: string]: unknown;
}

interface UserState {
  id: string | null;
  username: string | null;
  email: string | null;
  roles: string[];
  isLoggedIn: boolean;
  _hasHydrated: boolean;
  /** Sync store from the auth/me/ payload (call when session is available). */
  setFromSession: (user: SessionUser | null) => void;
  /** Clear user state (e.g. on signOut). */
  logout: () => void;
  setHasHydrated: (state: boolean) => void;
}

function userFromSession(user: SessionUser | null): Pick<UserState, "id" | "username" | "email" | "roles" | "isLoggedIn"> {
  if (!user) {
    return {
      id: null,
      username: null,
      email: null,
      roles: [],
      isLoggedIn: false,
    };
  }
  const id = user.id != null ? String(user.id) : null;
  return {
    id,
    username: user.username ?? null,
    email: user.email ?? null,
    roles: user.roles ?? [],
    isLoggedIn: true,
  };
}

export const useUserStore = create<UserState>((set) => ({
  id: null,
  username: null,
  email: null,
  roles: [],
  isLoggedIn: false,
  _hasHydrated: false,
  setFromSession: (user) => set((state) => ({ ...state, ...userFromSession(user) })),
  logout: () =>
    set({
      id: null,
      username: null,
      email: null,
      roles: [],
      isLoggedIn: false,
    }),
  setHasHydrated: (state) => set({ _hasHydrated: state }),
}));

export const useHasHydrated = () => useUserStore((s) => s._hasHydrated);
